/* any functionality that external components need, and thus must be exported, goes in this file */
export var findOptionByValue = function findOptionByValue(value, options, callback) {
  var foundIndex = options.findIndex(function (option) {
    var optionValue = typeof option === 'string' ? option : option.value;
    return optionValue === value;
  });
  callback(foundIndex);
};